module.exports = __webpack_public_path__ + "static/media/logo.153e6ca2.svg";